(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gcs-email-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dialog = document.querySelector('[data-gcs-email-popup]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'gcs-free-svg-popup-dismissed-v1';
  const returnKey = 'gcs-free-svg-popup-return-v1';
  const lifetime = 30 * 24 * 60 * 60 * 1000;
  let dismissed = false;
  let shown = false;
  let lastFocus = null;
  const started = Date.now();
  try { dismissed = Date.now() - Number(localStorage.getItem(key) || 0) < lifetime; } catch {}
  const remember = () => { dismissed = true; try { localStorage.setItem(key, String(Date.now())); } catch {} };
  const close = () => { remember(); dialog.close(); };
  const show = (feedback = false) => {
    if ((!feedback && dismissed) || shown || document.hidden || document.documentElement.classList.contains('shopify-design-mode')) return;
    if (document.querySelector('dialog[open]')) return;
    if (document.activeElement?.matches('input, textarea, select')) return;
    lastFocus = document.activeElement;
    shown = true;
    dialog.showModal();
    dialog.querySelector('[data-gcs-popup-close]')?.focus({preventScroll: true});
  };
  dialog.querySelectorAll('[data-gcs-popup-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('cancel', () => remember());
  dialog.addEventListener('close', () => { remember(); if (lastFocus?.isConnected) lastFocus.focus({preventScroll: true}); });
  dialog.addEventListener('click', event => { const box = dialog.getBoundingClientRect(); if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close(); });
  document.querySelectorAll('.gcs-signup-form').forEach(form => form.addEventListener('submit', () => { remember(); try { if (dialog.contains(form)) sessionStorage.setItem(returnKey, 'popup'); } catch {} }));
  try { if (sessionStorage.getItem(returnKey) === 'popup') { sessionStorage.removeItem(returnKey); if (dialog.querySelector('.errors, .gcs-signup-success')) show(true); } } catch {}
  if (window.matchMedia('(max-width: 767px), (pointer: coarse)').matches) {
    window.setTimeout(show, 15000);
  } else {
    document.addEventListener('mouseout', event => { if (!event.relatedTarget && event.clientY <= 0 && Date.now() - started > 4000) show(); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.querySelectorAll('.gcs-menu').forEach(menu=>{menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.open=false;}));document.addEventListener('click',event=>{if(!menu.contains(event.target))menu.open=false;});});

  } catch(e) { console.error(e); }
})();
})();
